import { Button } from '@material-ui/core';
import palette from 'assets/palette';
import styled from 'styled-components';

export interface FilterSummaryProps {
  parts: string[];
  resetLabel: string;
  onReset: () => void;
  disabled?: boolean;
}

// A table's top row: the page's refining fields and filter summary on the
// left, the paging stats on the right. On narrow screens the paging stats
// wrap below the fields and stay right-aligned.
export const PaginationRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  & > .MuiTablePagination-root {
    flex: none;
    margin-left: auto;
  }
`;

// Refining fields (client, project, employee) at the start of PaginationRow.
export const ToolbarFields = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  & > * {
    flex: none;
    width: 220px;
  }
`;

// Shrinks and wraps within its own space before it pushes the paging stats
// onto another line.
const Summary = styled.div`
  flex: 1 1 200px;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 12px;
  font-size: 0.875rem;
  color: ${palette.ACCENT_DARKEST};
`;

const Separator = styled.span`
  color: ${palette.ACCENT_LIGHT};
`;

export const FilterResetButton = styled(Button)`
  &.MuiButton-root {
    padding: 2px 8px;
    min-width: 0;
    text-transform: none;
    text-decoration: underline;
  }
`;

// Tells the user how the list differs from their default view, next to the
// paging stats, and offers one way back.
const FilterSummary = ({
  parts,
  resetLabel,
  onReset,
  disabled,
}: FilterSummaryProps) =>
  parts.length ? (
    <Summary role="status">
      {parts.map((part) => (
        <span key={part}>{part}</span>
      ))}
      <Separator aria-hidden="true">·</Separator>
      <FilterResetButton size="small" onClick={onReset} disabled={disabled}>
        {resetLabel}
      </FilterResetButton>
    </Summary>
  ) : null;

export default FilterSummary;
